<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}
</style>

<div class="bg">
  <div class="title-signup">First things first.  Are you creating a...</div>
  <div class="margin">
    <button on:click="{business}">Business Profile</button>
  </div>
  <div class="margin">
    <button on:click="{personal}">Personal Profile</button>
  </div>
  
  <div class="margin link" on:click="{ () => push('/login') }">Already have an account?</div>
  
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';


function business() {
  // push("");
}


function personal() {
  push("/signup/profile/personal/name");
}


</script>